module.exports = __webpack_public_path__ + "static/media/csrddc1.a1edc01d.svg";